import {
  UploadResponse,
  ImportAPIPayloadExamplesResponse,
} from '@ardoq/api-types/integrations';
import {
  CSRF_HEADER_NAME,
  Method,
  getCsrfToken,
  handleNetworkError,
  toApiResponse,
  toRequestOptions,
  fetchJson,
} from '../api';
import { ApiResponse } from '../types';
import { ArdoqId } from '@ardoq/api-types';

async function uploadFile(body: FormData): ApiResponse<UploadResponse> {
  const token = getCsrfToken();
  const request = new Request('/api/integrations/tabular/upload', {
    method: Method.POST,
    headers: token ? { [CSRF_HEADER_NAME]: token } : undefined,
    body,
  });

  return fetch(request)
    .then(toApiResponse<UploadResponse>)
    .catch(error => handleNetworkError(request, error));
}

async function getImportApiPayloadExamples(
  configId: ArdoqId
): ApiResponse<ImportAPIPayloadExamplesResponse> {
  const request = new Request(
    '/api/integrations/tabular/import/payload-examples',
    toRequestOptions(Method.POST, { config: { id: configId } })
  );

  return fetchJson<ImportAPIPayloadExamplesResponse>(request);
}

export const tabularApi = {
  uploadFile,
  getImportApiPayloadExamples,
};
